import { Injectable, Type } from "@angular/core";
import { Routes } from "@angular/router";
import { DynamicRoute, IDynamicRoutesProvider } from "core";
import { ORDERS_DESCRIBE } from "../constants";
import { Orders } from "../orders/orders"
import { NewOrderProposal } from "../new-order-proposal/new-order-proposal"

@Injectable({ providedIn: 'root' })
export class OrdersRoutesProvider extends IDynamicRoutesProvider {

    override componentMap: Record<string, Type<any>> = {
        'orders': Orders,
        'new-order-proposal': NewOrderProposal,
    };

    // deve corrispondere all'id nel json della chiamate delle rotte
    override describe(): String {
        return 'orders';
    }

    override evaluate(dynamicRoute: DynamicRoute[]): Routes {
        return this.buildRoutes(dynamicRoute, ORDERS_DESCRIBE);
    }
}
